
(function(){
  function whenImagesReady(el){
    const imgs = Array.from(el.querySelectorAll('img'));
    if (!imgs.length) return Promise.resolve();
    return Promise.all(imgs.map(img => img.complete ? Promise.resolve() : new Promise(res => {
      img.addEventListener('load', res, { once:true });
      img.addEventListener('error', res, { once:true });
    })));
  }

  function init(carousel){
    if (carousel.dataset.fcInit === '1') return;
    carousel.dataset.fcInit = '1';

    const track = carousel.querySelector('.fc-track');
    if (!track) return;

    const prev = carousel.querySelector('.fc-prev');
    const next = carousel.querySelector('.fc-next');

    const GAP   = parseFloat(getComputedStyle(track).getPropertyValue('--fc-gap')) || 32;
    const SPEED = 26; // px/sec

    // Duplicate once for seamless looping
    const originals = Array.from(track.children);
    if (!originals.length) return;
    const clones = originals.map(n => n.cloneNode(true));
    clones.forEach(n => track.appendChild(n));

    function stride(){
      const card = track.querySelector('[class*="#column"]');
      return card ? (card.getBoundingClientRect().width + GAP) : 0;
    }

    function originalWidth(){
      // After cloning, half the scrollWidth is the original content width
      return Math.max(track.scrollWidth / 2, 0);
    }

    function snapTo(left, behavior){
      const ow = originalWidth();
      if (!ow) return;
      let L = left % ow;
      if (L < 0) L += ow;
      track.scrollTo({ left: L, behavior: behavior || 'auto' });
    }

    function nextStep(){ const s = stride(); if (s) snapTo(track.scrollLeft + s, 'smooth'); pauseThenResume(); }
    function prevStep(){ const s = stride(); if (s) snapTo(track.scrollLeft - s, 'smooth'); pauseThenResume(); }

    prev && prev.addEventListener('click', (e)=>{ e.preventDefault(); stop(); prevStep(); });
    next && next.addEventListener('click', (e)=>{ e.preventDefault(); stop(); nextStep(); });

    // Continuous autoplay with rAF
    let raf = null, last = 0;
    function frame(ts){
      if (!last) last = ts;
      const dt = (ts - last)/1000; last = ts;
      track.scrollLeft += SPEED * dt;
      const ow = originalWidth();
      if (ow && track.scrollLeft >= ow) track.scrollLeft -= ow;
      raf = requestAnimationFrame(frame);
    }
    function start(){ if (!raf){ last = 0; raf = requestAnimationFrame(frame); } }
    function stop(){ if (raf){ cancelAnimationFrame(raf); raf = null; } }

    // Pause briefly after user interaction
    let resumeT;
    function pauseThenResume(){ clearTimeout(resumeT); resumeT = setTimeout(()=>start(), 900); }
    ['wheel','touchstart','touchmove','mousedown','keydown'].forEach(evt => {
      track.addEventListener(evt, ()=>{ stop(); pauseThenResume(); }, { passive: true });
    });
    document.addEventListener('visibilitychange', ()=>{ if (document.hidden) stop(); else start(); });

    whenImagesReady(track).then(()=>{
      // let layout settle, then start
      setTimeout(start, 60);
    });
  }

  function boot(root){ root.querySelectorAll('.featured-carousel').forEach(init); }
  document.addEventListener('DOMContentLoaded', ()=>boot(document));
  document.addEventListener('shopify:section:load', e => boot(e.target || document));
})();
